module.exports = __webpack_public_path__ + "img/star-filled.0a4d8c59.svg";